import styled from "styled-components";

export const StyledLazyLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
`;
